import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { publicRequest } from "../../requestMethods"
import { Send } from "@mui/icons-material"
// Styles
import {
   Container,
   Title,
   Description,
   InputContainer,
   Input,
   Button,
   Message,
} from "./Newsletter.styles"

const Newsletter = () => {
   const { t } = useTranslation()
   const [email, setEmail] = useState("")
   const [message, setMessage] = useState("")

   const handleSubmit = async (e) => {
      e.preventDefault()

      if ((!email.includes("@") || !email.includes(".")) && email !== "") {
         setMessage(t("newsletter.message.m1"))
      } else {
         try {
            await publicRequest.post("/emails", { emailAddress: email })
            setMessage(t("newsletter.message.m2"))
         } catch (err) {
            if (JSON.stringify(err.response.data).includes("keyValue")) {
               setMessage(t("newsletter.message.m3"))
            }
         }
      }
   }

   return (
      <Container id="newsletter">
         <Title>Newsletter</Title>
         <Description>{t("newsletter.text.t1")}</Description>
         <InputContainer>
            <Input
               placeholder={t("newsletter.input.i1")}
               onChange={(e) => setEmail(e.target.value)}
            ></Input>
            <Button>
               <Send onClick={(e) => handleSubmit(e)} />
            </Button>
         </InputContainer>
         <Message>{message}</Message>
      </Container>
   )
}

export default Newsletter
